import React, { useEffect, useState } from "react";
import { authFetch } from "../utils/authFetch";

import toastr from "toastr";
import "toastr/build/toastr.min.css";

const toast = (m, t = "success") => {
  toastr.options = {
    closeButton: true,
    progressBar: true,
    timeOut: 3000,
  };

  toastr[t](m);
};

const steps = [
  {
    id: 1,
    title: "Onboard",
    api: "/api/v1/member/TP/topay/onboard",
  },
  {
    id: 2,
    title: "Digitize KYC",
    api: "/api/v1/member/TP/topay/digikyc-start",
  },
  {
    id: 3,
    title: "Fetch Digitize KYC",
    api: "/api/v1/member/TP/topay/fetch-digikyc-status",
  },
  {
    id: 4,
    title: "Send Consent OTP",
    api: "/api/v1/member/TP/topay/send-otp",
  },
  {
    id: 5,
    title: "Register Wallet",
    api: "/api/v1/member/TP/topay/register-wallet",
  },
  {
    id: 6,
    title: "PAN OCR",
    api: "/api/v1/member/TP/topay/pan-ocr",
  },
  {
    id: 7,
    title: "Generate VCIP Link",
    api: "/api/v1/member/TP/topay/generate-vcip-link",
  },
  {
    id: 8,
    title: "VCIP Status",
    api: "/api/v1/member/TP/topay/vcip-status",
  },
  {
    id: 9,
    title: "Customer Lookup",
    api: "/api/v1/member/TP/topay/customer-lookup",
  },
  {
    id: 10,
    title: "Wallet Balance",
    api: "/api/v1/member/TP/topay/wallet-balance",
  },
  {
    id: 11,
    title: "Wallet Debit",
    api: "/api/v1/member/TP/topay/wallet-debit",
  },
  {
    id: 12,
    title: "Wallet Transactions",
    api: "/api/v1/member/TP/topay/wallet-transactions",
  },
  {
    id: 13,
    title: "Wallet Topup",
    api: "/api/v1/member/TP/topay/wallet-topup",
  },
  {
    id: 14,
    title: "Validate Wallet Pin",
    api: "/api/v1/member/TP/topay/validate-wallet-pin",
  },
  {
    id: 15,
    title: "Forget Wallet PIN",
    api: "/api/v1/member/TP/topay/forget-wallet-pin",
  },
  {
    id: 16,
    title: "Reset Wallet PIN",
    api: "/api/v1/member/TP/topay/reset-wallet-pin",
  },
  {
    id: 17,
    title: "Get Cards List",
    api: "/api/v1/member/TP/topay/get-cards-list",
  },
  {
    id: 18,
    title: "Card Details",
    api: "/api/v1/member/TP/topay/card-details",
  },
  {
    id: 19,
    title: "Card Actions",
    api: "/api/v1/member/TP/topay/card-actions",
  },
  {
    id: 20,
    title: "Request Physical Card",
    api: "/api/v1/member/TP/topay/request-physical-card",
  },
  {
    id: 21,
    title: "Fetch Card Preference",
    api: "/api/v1/member/TP/topay/fetch-card-preference",
  },
  {
    id: 22,
    title: "Set Card Preference",
    api: "/api/v1/member/TP/topay/set-card-preference",
  },
  {
    id: 23,
    title: "Register Merchant Profile",
    api: "/api/v1/member/TP/topay/register-merchant-profile",
  },
  {
    id: 24,
    title: "Get Merchant Profile",
    api: "/api/v1/member/TP/topay/get-merchant-profile",
  },
  {
    id: 25,
    title: "Webhook Configuration",
    api: "/api/v1/member/TP/topay/webhook-configuration",
  },
];

export default function TopayOnboardingWizard() {

  // =========================================
  // LOADING
  // =========================================
  const userData = JSON.parse(localStorage.getItem("user"));
  const user_id = userData?.id;
  const [loading, setLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [digikycStarted, setDigikycStarted] = useState(false);
  // =========================================
  // STEP STATES
  // =========================================

  const [currentStep, setCurrentStep] = useState(1);

  const [completedSteps, setCompletedSteps] = useState([]);

  // =========================================
  // FORMS
  // =========================================

  const [registerForm, setRegisterForm] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const [otpForm, setOtpForm] = useState({
    otp: "",
  });

  const [walletForm, setWalletForm] = useState({

    maritalStatus: "",

    employmentIndustry: "",

    employmentType: "",

    accountno: "",

    bankName: "",

    branchName: "",

    ifscCode: ""
  });

  const [merchantProfileForm, setMerchantProfileForm] = useState({

    legalName: "",

    mccCode: "",

    merchantType: "",

    merchantGenre: "",

    brandName: "",

    ownershipType: ""
  });

  const [panImage, setPanImage] = useState("");

  // =========================================
  // MERCHANT
  // =========================================

  const [selectedMerchant, setSelectedMerchant] =
    useState(null);

  const [vcipLink, setVcipLink] = useState("");

  // =========================================
  // STEP HELPERS
  // =========================================

  const completeStep = (stepNumber) => {

    if (!completedSteps.includes(stepNumber)) {

      setCompletedSteps((prev) => [
        ...prev,
        stepNumber,
      ]);
    }

    setCurrentStep(stepNumber + 1);
  };

  const isStepCompleted = (step) => {
    return completedSteps.includes(step);
  };

  const isStepActive = (step) => {
    return currentStep === step;
  };

  // =========================================
  // DEVICE INFO HELPER
  // =========================================

  const getDeviceInfo = async (mobile) => {

    return new Promise((resolve, reject) => {

      navigator.geolocation.getCurrentPosition(

        async (position) => {

          try {

            const lat = position.coords.latitude;

            const lng = position.coords.longitude;

            // =====================================
            // IP DETAILS
            // =====================================

            const ipRes = await fetch(
              "https://ip-api.com/json/"
            );

            const ipData = await ipRes.json();

            // =====================================
            // DEVICE INFO
            // =====================================

            const deviceInfo = {

              deviceId:
                crypto.randomUUID(),

              deviceType:
                /Mobi|Android/i.test(
                  navigator.userAgent
                )
                  ? "MOB"
                  : "WEB",

              os:
                navigator.platform,

              appVersion:
                "3.5.1",

              telecom:
                ipData?.isp || "",

              geoCode:
                `${lat},${lng}`,

              appId:
                window.location.hostname,

              ipAddress:
                ipData?.query || "",

              location:
                `${ipData?.city},${ipData?.country}`,

              simId:
                crypto.randomUUID(),

              mobile:
                mobile
            };

            resolve(deviceInfo);

          } catch (err) {

            reject(err);
          }
        },

        (error) => {

          reject(error);
        }
      );
    });
  };
  // =========================================
  // COMMON API
  // =========================================

  const postApi = async (url, payload) => {

    const res = await authFetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    // =====================================
    // SAVE RESPONSE
    // =====================================

    setApiResponse({

      url,

      payload,

      response: data,

      status: res.status,

      success: res.ok,
    });

    if (!res.ok) {
      throw new Error(data.message || "Request Failed");
    }

    return data;
  };

  // =========================================
  // REGISTER MERCHANT
  // =========================================

  const handleRegisterMerchant = async () => {

    try {

      if (!registerForm.name) {
        return toast("Enter Name", "warning");
      }

      if (!registerForm.mobile) {
        return toast("Enter Mobile", "warning");
      }

      setLoading(true);

      const data = await postApi(
        "/api/v1/member/TP/topay/onboard",
        registerForm
      );
      
      setApiResponse(data);

      setSelectedMerchant({
        merchantId:
          data?.merchantId ||
          data?.data?.merchantId,

        status:
          data?.status ||
          data?.data?.status,
      });

      toast(
        data.message ||
        "Merchant Registered"
      );

      completeStep(1);

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };

  // DIGI Kyc
  const handleDigikycStart = async () => {

    try {

      setLoading(true);

      const data = await postApi(
        "/api/v1/member/TP/topay/digikyc-start",
        {
          user_id,
          merchantId:
            selectedMerchant?.merchantId,

          mobile:
            registerForm.mobile,
        }
      );

      // SAVE RESPONSE
      setApiResponse(data);

      // DISABLE BUTTON
      setDigikycStarted(true);

      toast(
        data.message ||
        "Digikyc Started"
      );

      completeStep(2);

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };

  // Fetch Digikyc Status
  const handleFetchDigikycStatus = async () => {

    try {

      setLoading(true);

      const data = await postApi(
        "/api/v1/member/TP/topay/fetch-digikyc-status",
        {
          merchantId:
            selectedMerchant?.merchantId,

          mobile:
            registerForm.mobile,
        }
      );

      // =========================
      // SAVE RESPONSE
      // =========================

      setApiResponse(data);

      // =========================
      // SUCCESS
      // =========================

      if (data?.status === "success") {

        toast(
          "DigiKYC Completed"
        );

        completeStep(3);

      }

      // =========================
      // PENDING
      // =========================

      else if (
        data?.status === "pending"
      ) {

        toast(
          "DigiKYC Pending",
          "warning"
        );
      }

      // =========================
      // FAILED
      // =========================

      else {

        toast(
          "DigiKYC Failed",
          "error"
        );
      }

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };

  // send Otp
  const handleSendOtp = async () => {

    try {

      setLoading(true);

      const data = await postApi(
        "/api/v1/member/TP/topay/send-otp",
        {
          merchantId:
            selectedMerchant?.merchantId,

          mobile:
            registerForm.mobile,
        }
      );

      toast(
        data.message ||
        "Consent OTP Sent"
      );

      completeStep(4);

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };

  //register wallet
  const handleRegisterWallet = async () => {

    try {

      if (!otpForm.otp) {

        return toast(
          "Enter OTP",
          "warning"
        );
      }

      setLoading(true);

      // =====================================
      // GET DEVICE INFO
      // =====================================

      const deviceInfo = await getDeviceInfo(
        registerForm.mobile
      );

      // =====================================
      // API
      // =====================================

      const data = await postApi(
        "/api/v1/member/TP/topay/register-wallet",
        {

          merchantId:
            selectedMerchant?.merchantId,

          mobile:
            registerForm.mobile,

          otp:
            otpForm.otp,

          maritalStatus:
            walletForm.maritalStatus,

          employmentIndustry:
            walletForm.employmentIndustry,

          employmentType:
            walletForm.employmentType,

          ipAddress:
            deviceInfo.ipAddress,

          accountno:
            walletForm.accountno,

          bankName:
            walletForm.bankName,

          branchName:
            walletForm.branchName,

          ifscCode:
            walletForm.ifscCode,

          deviceInfo
        }
      );

      // ===================================
      // SUCCESS
      // ===================================

      toast(
        data.message ||
        "Wallet Registered"
      );

      completeStep(5);

    } catch (err) {

      console.log(err);

      toast(
        err.message,
        "error"
      );

    } finally {

      setLoading(false);
    }
  };

  //Convert to base64 String
  const convertToBase64 = (file) => {

    return new Promise((resolve, reject) => {

      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result.split(",")[1]);
      };

      reader.onerror = reject;
    });
  };

  // UPLOAD PAN
  const handlePanUpload = async (e) => {

    try {

      const file = e.target.files[0];

      if (!file) return;

      const base64 = await convertToBase64(file);

      setPanImage(base64);

      toast("PAN Uploaded");

    } catch (err) {

      toast("Upload Failed", "error");
    }
  };

  // PAN OCR
  const handlePanOcr = async () => {

    try {

      if (!panImage) {
        return toast("Upload PAN", "warning");
      }

      setLoading(true);

      await postApi(
        "/api/v1/member/topay/pan-ocr",
        {
          merchantId: selectedMerchant?.merchantId,
          ocrimage: panImage,
        }
      );

      toast("PAN OCR Success");

      completeStep(3);

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };

  // Generate START VCIP
  const handleStartVcip = async () => {

    try {

      setLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/start-vcip",
        {
          merchantId: selectedMerchant?.merchantId,
        }
      );

      setVcipLink(data?.data?.vcipUrl || "");

      toast("VCIP Started");

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };

  // CHECK VCIP STATUS
  const handleCheckVcip = async () => {

    try {

      setLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/vcip-status",
        {
          merchantId: selectedMerchant?.merchantId,
        }
      );

      if (data?.data?.state === "Success") {

        toast("VCIP Completed");

        completeStep(4);

      } else {

        toast("VCIP Pending", "warning");
      }

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };
  
  // Register Merchant Profile
  const handleRegisterMerchantProfile = async () => {

    try {

      setLoading(true);

      // =====================================
      // GET DEVICE INFO
      // =====================================

      const deviceInfo = await getDeviceInfo(
        registerForm.mobile
      );

      // =====================================
      // PAYLOAD
      // =====================================

      const payload = {

        merchantId:
          selectedMerchant?.merchantId,

        legalName:
          merchantProfileForm.legalName,

        mccCode:
          merchantProfileForm.mccCode,

        merchantType:
          merchantProfileForm.merchantType,

        merchantGenre:
          merchantProfileForm.merchantGenre,

        brandName:
          merchantProfileForm.brandName,

        ownershipType:
          merchantProfileForm.ownershipType,

        deviceInfo
      };

      console.log(
        "REGISTER MERCHANT PROFILE PAYLOAD:",
        payload
      );

      const data = await postApi(
        "/api/v1/member/topay/register-merchant-profile",
        payload
      );

      toast(
        data?.message ||
        "Merchant Profile Registered"
      );

      completeStep(23);

    } catch (err) {

      console.log(err);

      toast(
        err.message ||
        "Register Merchant Profile Failed",
        "error"
      );

    } finally {

      setLoading(false);
    }
  };
  

  

  

  // =========================================
  // JSX
  // =========================================

  return (
    <>
    <style>
        {`
            .wizard-scroll {
            display: flex;
            gap: 12px;
            overflow-x: auto;
            overflow-y: hidden;
            padding-bottom: 6px;
            white-space: nowrap;
            scrollbar-width: thin;
            scrollbar-color: #673ab7 #e9ecef;
            }

            .wizard-scroll::-webkit-scrollbar {
            height: 4px;
            }

            .wizard-scroll::-webkit-scrollbar-track {
            background: #e9ecef;
            border-radius: 20px;
            }

            .wizard-scroll::-webkit-scrollbar-thumb {
            background: #673ab7;
            border-radius: 20px;
            }

            .wizard-scroll::-webkit-scrollbar-thumb:hover {
            background: #562c9c;
            }

            .wizard-step {
            min-width: 150px;
            padding: 12px 16px;
            border-radius: 10px;
            border: 1px solid #dee2e6;
            text-align: center;
            flex-shrink: 0;
            transition: 0.3s;
            }

            .wizard-active {
            background: #673ab7;
            color: white;
            }

            .wizard-completed {
            background: #32ab13;
            color: white;
            }

            .wizard-pending {
            background: #f8f9fa;
            color: #212529;
            }
        `}
    </style>

      {/* <div className="page-wrapper"> */}

        {/* <div className="page-content-wrapper"> */}

          <div className="page-content">

            <div className="card">

              <div className="card-header">
                Topay Onboarding Wizard
              </div>

              <div className="card-body">

                {/* ===================================== */}
                {/* STEP HEADER */}
                {/* ===================================== */}

                <div className="wizard-scroll">

                    {steps.map((step) => (

                        <div
                        key={step.id}
                        className={`
                            wizard-step
                            ${
                            isStepCompleted(step.id)
                                ? "wizard-completed"
                                : isStepActive(step.id)
                                ? "wizard-active"
                                : "wizard-pending"
                            }
                        `}
                        >
                        <div>
                            Step {step.id}
                        </div>

                        <strong>
                            {step.title}
                        </strong>
                        </div>
                    ))}

                </div>  
                

                {/* ===================================== */}
                {/* STEP 1 */}
                {/* ===================================== */}

                {currentStep === 1 && (
                  
                  <div className="card border p-4">

                    <h4 className="mb-4">
                      Register Merchant
                    </h4>

                    <div className="row">

                      <div className="col-md-4 mb-3">

                        <label>Name</label>

                        <input
                          type="text"
                          className="form-control"
                          value={registerForm.name}
                          onChange={(e) =>
                            setRegisterForm({
                              ...registerForm,
                              name: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="col-md-4 mb-3">

                        <label>Email</label>

                        <input
                          type="email"
                          className="form-control"
                          value={registerForm.email}
                          onChange={(e) =>
                            setRegisterForm({
                              ...registerForm,
                              email: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="col-md-4 mb-3">

                        <label>Mobile</label>

                        <input
                          type="text"
                          className="form-control"
                          value={registerForm.mobile}
                          onChange={(e) =>
                            setRegisterForm({
                              ...registerForm,
                              mobile: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <button
                      className="btn btn-primary"
                      onClick={handleRegisterMerchant}
                      disabled={loading}
                    >
                      {
                        loading
                          ? "Please Wait..."
                          : "Register Merchant"
                      }
                    </button>

                    {/* ===================================== */}
                    {/* API RESPONSE */}
                    {/* ===================================== */}

                    {
                      apiResponse && (

                        <div className="mt-4">

                          <h5>
                            API Response
                          </h5>

                          <pre
                            style={{
                              background: "#f4f4f4",
                              padding: "15px",
                              borderRadius: "10px",
                              fontSize: "13px",
                              overflowX: "auto"
                            }}
                          >
                            {
                              JSON.stringify(
                                apiResponse,
                                null,
                                2
                              )
                            }
                          </pre>
                        </div>
                      )
                    }
                  </div>
                )}

                {/* ===================================== */}
                {/* STEP 2 */}
                {/* ===================================== */}

                {currentStep === 2 && (

                  <div className="card border p-4">

                    <h4 className="mb-4">
                      DigiKYC Verification
                    </h4>

                    <p className="text-muted">

                      Start DigiKYC and complete Aadhaar verification.

                    </p>

                    {/* ========================= */}
                    {/* BUTTONS */}
                    {/* ========================= */}

                    <div className="d-flex gap-2 flex-wrap">

                      {/* START DIGIKYC */}

                      <button
                        className="btn btn-primary"
                        onClick={handleDigikycStart}
                        disabled={
                          loading ||
                          digikycStarted
                        }
                      >
                        {
                          digikycStarted
                            ? "DigiKYC Started"
                            : loading
                            ? "Please Wait..."
                            : "Start DigiKYC"
                        }
                      </button>

                      {/* OPEN DIGIKYC */}

                      {
                        apiResponse?.kyc_url && (

                          <a
                            href={apiResponse.kyc_url}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-success"
                          >
                            Open DigiKYC
                          </a>
                        )
                      }

                      {/* CHECK STATUS */}

                      <button
                        className="btn btn-dark"
                        onClick={
                          handleFetchDigikycStatus
                        }
                        disabled={loading}
                      >
                        {
                          loading
                            ? "Checking..."
                            : "Check Status"
                        }
                      </button>

                    </div>

                    {/* ========================= */}
                    {/* STATUS */}
                    {/* ========================= */}

                    {
                      apiResponse?.status && (

                        <div className="mt-4">

                          <span
                            className={`
                              badge
                              ${
                                apiResponse?.status === "success"
                                  ? "bg-success"
                                  : apiResponse?.status === "pending"
                                  ? "bg-warning"
                                  : "bg-danger"
                              }
                            `}
                          >
                            Status :
                            {" "}
                            {apiResponse?.status}
                          </span>

                        </div>
                      )
                    }

                    {/* ========================= */}
                    {/* RESPONSE */}
                    {/* ========================= */}

                    {
                      apiResponse && (

                        <div className="mt-4">

                          <h5>
                            API Response
                          </h5>

                          <pre
                            style={{
                              background: "#f4f4f4",
                              padding: "15px",
                              borderRadius: "10px",
                              fontSize: "13px",
                              overflowX: "auto"
                            }}
                          >
                            {
                              JSON.stringify(
                                apiResponse,
                                null,
                                2
                              )
                            }
                          </pre>

                        </div>
                      )
                    }

                  </div>
                )}

                {/* ===================================== */}
                {/* STEP 3 */}
                {/* ===================================== */}

                {currentStep === 3 && (

                  <div className="card border p-4">

                    <h4 className="mb-4">
                      PAN OCR
                    </h4>

                    <div className="mb-3">

                      <label>
                        Upload PAN
                      </label>

                      <input
                        type="file"
                        className="form-control"
                        onChange={handlePanUpload}
                      />
                    </div>

                    <button
                      className="btn btn-primary"
                      onClick={handlePanOcr}
                      disabled={loading}
                    >
                      {
                        loading
                          ? "Please Wait..."
                          : "Verify PAN"
                      }
                    </button>
                  </div>
                )}

                {/* ===================================== */}
                {/* STEP 4 */}
                {/* ===================================== */}

                {currentStep === 4 && (

                  <div className="card border p-4">

                    <h4 className="mb-4">
                      VKYC
                    </h4>

                    <div className="d-flex gap-2">

                      <button
                        className="btn btn-primary"
                        onClick={handleStartVcip}
                      >
                        Start VCIP
                      </button>

                      <button
                        className="btn btn-success"
                        onClick={handleCheckVcip}
                      >
                        Check Status
                      </button>
                    </div>

                    {
                      vcipLink && (
                        <div className="mt-4">

                          <a
                            href={vcipLink}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-dark"
                          >
                            Open VCIP Link
                          </a>
                        </div>
                      )
                    }
                  </div>
                )}

                {/* ===================================== */}
                {/* COMPLETED */}
                {/* ===================================== */}

                {currentStep > 4 && (

                  <div className="alert alert-success">

                    <h4>
                      Onboarding Completed
                    </h4>

                    <p className="mb-0">
                      All steps completed successfully.
                    </p>

                  </div>
                )}

              </div>
            </div>
          </div>
        {/* </div> */}
      {/* </div> */}
    </>
  );
}